import { render, staticRenderFns } from "./index.vue?vue&type=template&id=47d9110c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=47d9110c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d9110c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BannerSwiper: require('/var/www/mbm.garena.all/frontend/components/BannerSwiper.vue').default,CategoryList: require('/var/www/mbm.garena.all/frontend/components/CategoryList.vue').default,Loading: require('/var/www/mbm.garena.all/frontend/components/Loading.vue').default})
